import { type Dispatch, type SetStateAction, useState } from "react";
import apiRequest from "../../../../../../utils/ApiRequest/apiRequest.js";
import Button from "../../../../../Elements/Button/Button.js";
import InputElement from "components/Elements/InputElement/InputElement.js";
import LoadingImageElement from "../../../../../Elements/LoadingContainerElement/LoadingImageElement.tsx";
import ToastHtmlComponent from "../../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

//@ts-ignore
import config from "config";
import { multipleBlanksFilter, onlyDigits } from "helpers/filters.ts";

interface InvoiceModalI {
  UserId: number;
  UserInvoiceId: string;
  UserInvoiceName: string;
  setInvoiceDetails: Dispatch<
    SetStateAction<{
      Name: string;
      CompanyId: string;
    }>
  >;
}

const InvoiceModal = (props: InvoiceModalI) => {
  const { UserId, UserInvoiceId, UserInvoiceName, setInvoiceDetails } = props;
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const [invoiceId, setInvoiceId] = useState(UserInvoiceId);
  const [invoiceName, setInvoiceName] = useState(UserInvoiceName);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const editInvoiceDetails = async () => {
    if (!invoiceName)
      return setError(getTextByKey("default-input-invalid-message"));
    setLoading(true);

    const body = {
      UserId: UserId,
      InvoiceId: invoiceId,
      InvoiceName: invoiceName,
    };

    const response = await apiRequest(
      "Users",
      "UpdateUserInvoice",
      body,
      "POST"
    );

    setLoading(false);

    if (response.status === "success") {
      setInvoiceDetails({
        Name: invoiceName,
        CompanyId: invoiceId,
      });
    } else {
      let errText = getTextByKey("api-error");

      errText = errText.replace("#ERRORNUM#", 999);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config!.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");

      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }
    closeModal();
  };

  return (
    <div className="invoice-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <h1>{getTextByKey("payment-invoice-change-title")}</h1>
              <InputElement
                inputLabel={getTextByKey("payment-invoice-company-id")}
                state={invoiceId}
                setState={(v) => setInvoiceId(onlyDigits(v))}
                isColumn
                specificClass={undefined}
                inputTooltip={undefined}
                placeholder={undefined}
                icon={undefined}
              />
              <InputElement
                inputLabel={getTextByKey("payment-invoice-name")}
                state={invoiceName}
                setState={(v) => {
                  setError("");
                  setInvoiceName(multipleBlanksFilter(v));
                }}
                isColumn
                specificClass={undefined}
                inputTooltip={undefined}
                placeholder={undefined}
                icon={undefined}
                errorObject={{ isShow: !!error, errorText: error }}
              />
            </div>
            <div className="actions">
              <Button
                blank
                buttonClass="invoice-button"
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("cancel")}
              </Button>
              <Button
                buttonClass="invoice-button"
                disabled={!!error || loading}
                onClick={() => {
                  editInvoiceDetails();
                }}
              >
                {loading ? (
                  <LoadingImageElement />
                ) : (
                  getTextByKey("payment-invoice-btn-ok")
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceModal;
